import React, { Suspense, lazy, useEffect } from 'react'
import { DebugToolErrorBoundary } from './components/DebugToolErrorBoundary'
import { initializeDebugToolCapture } from './debugToolInit'
import { useDebugToolVisibility } from './debugToolVisibility'

const DebugTool = lazy(() => import('./DebugTool'))

type DebugToolRootProps = {
  children: React.ReactNode
  phoneNumber: string
  isUserDetailsLoading: boolean
}

export function DebugToolRoot({
  children,
  phoneNumber,
  isUserDetailsLoading
}: DebugToolRootProps) {
  const { enabled, captureMode } = useDebugToolVisibility(phoneNumber, isUserDetailsLoading)

  useEffect(() => {
    try {
      initializeDebugToolCapture(captureMode)
    } catch {
      // Optional tooling — never break the app shell
    }
  }, [captureMode])

  if (!enabled) return <>{children}</>

  return (
    <>
      {children}
      <DebugToolErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <DebugTool />
        </Suspense>
      </DebugToolErrorBoundary>
    </>
  )
}
